/* PARFUMPROBEN VERSAND – Filterleiste der Kollektion (gehört zu ppv-collection-filters.css).
   Ergänzt die Theme-Filter:
   - Desktop: Herren/Damen/Unisex als Umschalt-Chips (steuern die Geschlecht-Checkboxen des Theme-Filters).
   - Handy: derselbe Filter als Auswahl „Geschlecht“ (Herren/Damen/Unisex) wie die übrigen Filter.
   - Geschlecht ist überall eine Einfachauswahl (Damen ersetzt Herren statt es zu ergänzen).
   - Aktive Filter: „Marke · 2“ und ✕ statt Pfeil – ein Tipp auf ✕ entfernt den Filter sofort.
   - Trefferzahl neben der Überschrift folgt dem Filter, Sortier-Chip mit kurzem Namen, „Fertig“ im Auswahlblatt (Handy),
     immer nur ein offenes Auswahlfenster, abgeblendetes Raster während des Ladens und „Mehr anzeigen“ ohne Seitenwechsel.
   - Handy: Filter und Sortieren in einer Leiste zum Wischen; ein geöffneter Filter zieht für die Auswahl aus der Leiste.
   - Duftprofil-Filter (10/2026): Duftrichtung/Jahreszeit/Anlass/Stil aus den Metafeldern „duftprofil.*“ bekommen eigene Schlüssel
     (Reihenfolge am Handy, zweispaltige Duftrichtung); Reihenfolge der Werte: snippets/ppv-filter-order.liquid. */
(() => {
  if (window.__PPV_FILTERBAR__) return;
  window.__PPV_FILTERBAR__ = true;

  const GENDER_LABELS = { 'mannlich': 'Herren', 'maennlich': 'Herren', 'herren': 'Herren', 'weiblich': 'Damen', 'damen': 'Damen', 'unisex': 'Unisex' };
  const SORT_LABELS = {
    'manual': 'Empfohlen',
    'most-relevant': 'Relevanz',
    'best-selling': 'Beliebtheit',
    'title-ascending': 'A–Z',
    'title-descending': 'Z–A',
    'price-ascending': 'Preis aufsteigend',
    'price-descending': 'Preis absteigend',
    'created-descending': 'Neueste zuerst',
    'created-ascending': 'Älteste zuerst'
  };
  /* Zuordnung über die ID des Filters (enthält den URL-Parameter, z. B. filter.p.m.duftprofil.duftrichtungen).
     Duftprofil-Filter (10/2026): Duftrichtung, Jahreszeiten, Anlässe („anlaesse“), Stilrichtung, Zielgruppe. */
  const FILTER_KEYS = [
    [/gender|geschlecht|zielgruppe/, 'gender'],
    [/vendor|marke/, 'brand'],
    [/duftrichtung/, 'scent'],
    [/season|jahreszeit/, 'season'],
    [/occasion|anlass|anlaess/, 'occasion'],
    [/stilrichtung/, 'style'],
    [/price|preis/, 'price']
  ];
  const X_ICON = '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M1.5 1.5l7 7M8.5 1.5l-7 7"/></svg>';
  const norm = value => String(value || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();

  const labelOf = details => details.querySelector('.facets__summary-label') || details.querySelector('.facets__summary span');
  const baseLabel = element => element.textContent.replace(/\(\s*\d+\s*\)/g, '').replace(/\s+/g, ' ').trim();
  const filterKey = details => (FILTER_KEYS.find(([pattern]) => pattern.test(norm(details.id))) || [null, 'other'])[1];

  const activeCount = details => {
    const checked = details.querySelectorAll('input[type="checkbox"]:checked').length;
    if (checked) return checked;
    return [...details.querySelectorAll('price-range input')].some(input => input.value.trim() !== '') ? -1 : 0;
  };

  /* Geschlecht ist eine Einfachauswahl: ein neues Häkchen ersetzt das bisherige (Herren + Damen zusammen ergäben fast alle Düfte).
     Läuft im selben Ereignis vor dem verzögerten Absenden des Themes, das Formular wird also schon mit nur einem Wert gelesen. */
  function exclusiveGender(input) {
    const gender = input.closest('.ppv-gender-details');
    if (!gender || !input.checked) return;
    gender.querySelectorAll('input[type="checkbox"]:checked').forEach(other => {
      if (other !== input) other.checked = false;
    });
  }

  /* Anzeigename eines Geschlecht-Werts: „Männlich (348)“ → „Herren“ */
  function genderName(input) {
    const label = input.closest('label');
    const raw = (label?.querySelector('span[aria-hidden="true"]')?.textContent || label?.textContent || input.value)
      .replace(/\(.*$/s, '')
      .trim();
    return GENDER_LABELS[norm(raw)] || raw;
  }

  /* Geschlecht: Optionen „Männlich/Weiblich“ als „Herren/Damen“ anzeigen (Zahl in Klammern bleibt). */
  function relabelGender(gender) {
    gender.querySelectorAll('label').forEach(label => {
      label.querySelectorAll('span').forEach(span => {
        const text = span.textContent;
        const match = text.match(/^\s*([^(]+?)\s*(\(.*)?$/s);
        if (!match) return;
        const nice = GENDER_LABELS[norm(match[1])];
        if (!nice || nice === match[1].trim()) return;
        span.textContent = match[2] ? `${nice} ${match[2].trim()}` : nice;
      });
    });
  }

  function genderChips(wrapper, gender) {
    let chips = wrapper.querySelector(':scope > .ppv-chips');
    if (!gender) {
      chips?.remove();
      return;
    }
    gender.classList.add('ppv-gender-details');
    relabelGender(gender);
    const inputs = [...gender.querySelectorAll('input[type="checkbox"]')];
    if (!chips) {
      chips = document.createElement('div');
      chips.className = 'ppv-chips';
      chips.setAttribute('role', 'group');
      chips.setAttribute('aria-label', 'Geschlecht');
    }
    if (wrapper.firstElementChild !== chips) wrapper.prepend(chips);
    const signature = inputs.map(input => `${input.id}:${input.checked}:${input.disabled}`).join('|');
    if (chips.dataset.signature === signature) return;
    chips.dataset.signature = signature;
    chips.replaceChildren(...inputs.map(input => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'ppv-chip';
      const text = document.createElement('span');
      text.textContent = genderName(input);
      button.append(text);
      button.insertAdjacentHTML('beforeend', `<span class="ppv-chip__x">${X_ICON}</span>`);
      button.setAttribute('aria-pressed', String(input.checked));
      button.disabled = input.disabled && !input.checked;
      /* Das Theme ersetzt nach jedem Filtern den Inhalt der Filter (gleiche IDs, neue Elemente) – darum beim Klick die aktuelle
         Checkbox über ihre ID holen. Sonst schaltet der Chip eine nicht mehr vorhandene Checkbox und es wird nicht gefiltert. */
      const current = field => (field && document.getElementById(field.id)) || field;
      button.addEventListener('click', () => {
        const live = current(input);
        live.checked = !live.checked;
        live.dispatchEvent(new Event('input', { bubbles: true }));
        chips.querySelectorAll('.ppv-chip').forEach((chip, index) => chip.setAttribute('aria-pressed', String(!!current(inputs[index])?.checked)));
      });
      return button;
    }));
  }

  /* ✕ an aktiven Filtern: nutzt den „Zurücksetzen“-Link des Themes (sofortige Aktualisierung), sonst Häkchen entfernen. */
  function clearFilter(details) {
    details.removeAttribute('open');
    const reset = details.querySelector('facet-remove a, a.facets__reset');
    if (reset) {
      reset.click();
      return;
    }
    let changed = null;
    details.querySelectorAll('input[type="checkbox"]:checked').forEach(input => {
      input.checked = false;
      changed = input;
    });
    details.querySelectorAll('price-range input').forEach(input => {
      if (input.value) {
        input.value = '';
        changed = input;
      }
    });
    changed?.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function clearButton(details, active, name) {
    const summary = details.querySelector(':scope > summary');
    if (!summary) return;
    let clear = summary.querySelector('.ppv-chip-clear');
    if (!active) {
      clear?.remove();
      return;
    }
    if (clear) return;
    clear = document.createElement('span');
    clear.className = 'ppv-chip-clear';
    clear.setAttribute('role', 'button');
    clear.setAttribute('tabindex', '0');
    clear.setAttribute('aria-label', `Filter „${name}“ entfernen`);
    clear.innerHTML = X_ICON;
    const run = event => {
      event.preventDefault();
      event.stopPropagation();
      clearFilter(details);
    };
    clear.addEventListener('click', run);
    clear.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') run(event);
    });
    (summary.querySelector(':scope > div') || summary).append(clear);
  }

  function menuChips(details) {
    const label = labelOf(details);
    if (!label) return;
    const key = filterKey(details);
    if (details.dataset.ppvKey !== key) details.dataset.ppvKey = key;
    const name = label.dataset.ppvName || (label.dataset.ppvName = baseLabel(label));
    const count = activeCount(details);
    /* Geschlecht (Einfachauswahl): den gewählten Wert zeigen („Herren ✕“) statt „Geschlecht · 1“ */
    const picked = key === 'gender' && count > 0 ? details.querySelector('input[type="checkbox"]:checked') : null;
    const text = picked ? genderName(picked) : name;
    if (label.textContent !== text) label.textContent = text;
    details.classList.toggle('ppv-is-active', count !== 0);
    if (count > 0 && !picked) {
      if (label.dataset.ppvCount !== String(count)) label.dataset.ppvCount = String(count);
    } else if (label.dataset.ppvCount) {
      delete label.dataset.ppvCount;
    }
    clearButton(details, count !== 0, name);
    /* Handy: „Fertig“ schließt das Auswahlblatt */
    const display = details.querySelector('.facets__display');
    if (display && !display.querySelector(':scope > .ppv-sheet-done')) {
      const done = document.createElement('button');
      done.type = 'button';
      done.className = 'ppv-sheet-done';
      done.textContent = 'Fertig';
      done.addEventListener('click', () => {
        details.removeAttribute('open');
        details.querySelector('summary')?.focus({ preventScroll: true });
      });
      display.append(done);
    }
  }

  /* Sortier-Chip: sichtbarer Wert neben „Sortieren“, das (unsichtbare) Auswahlfeld liegt über der ganzen Pille. */
  function sorting(root) {
    root.querySelectorAll('.facet-filters__sort').forEach(select => {
      [...select.options].forEach(option => {
        const label = SORT_LABELS[option.value];
        if (label && option.textContent.trim() !== label) option.textContent = label;
      });
      if (select.style.width) select.style.removeProperty('width');
      const holder = select.parentElement;
      let value = holder.querySelector(':scope > .ppv-sort-value');
      if (!value) {
        value = document.createElement('span');
        value.className = 'ppv-sort-value';
        value.setAttribute('aria-hidden', 'true');
        holder.insertBefore(value, select);
      }
      const text = select.selectedOptions[0]?.textContent.trim() || '';
      if (value.textContent !== text) value.textContent = text;
    });
    root.querySelectorAll('.facet-filters__label label').forEach(label => {
      if (label.textContent.trim() !== 'Sortieren') label.textContent = 'Sortieren';
    });
  }

  /* Trefferzahl neben der Überschrift („348 Düfte“) aus der Zählung des Themes übernehmen. */
  function headingCount() {
    const target = document.querySelector('.ppv-collection-heading__count');
    const source = document.getElementById('ProductCountDesktop') || document.getElementById('ProductCount');
    if (!target || !source) return;
    const number = (source.textContent.match(/\d[\d.]*/) || [])[0];
    if (!number) return;
    const word = target.dataset.ppvWord || (target.dataset.ppvWord = target.textContent.replace(/^[\d.\s]+/, '').trim());
    const value = parseInt(number.replace(/\./g, ''), 10);
    const singular = word === 'Düfte' ? 'Duft' : word === 'Produkte' ? 'Produkt' : word;
    const text = `${value} ${value === 1 ? singular : word}`;
    if (target.textContent !== text) target.textContent = text;
  }

  /* Handy: Filter und Sortieren in einer Leiste zum Wischen (#FacetsWrapperDesktop). In einem seitlich scrollenden Container schneidet
     Safari (iPhone) das Auswahlblatt ab – darum zieht ein geöffneter Filter für die Dauer der Auswahl in den Halter unter der Leiste,
     ein Platzhalter hält seine Stelle, beim Schließen kehrt er zurück. Beides bleibt im Formular: Das Theme findet den Filter beim
     Neuzeichnen über seine ID und liest seine Häkchen und das Sortierfeld weiter mit. */
  const mobile = window.matchMedia('(max-width: 749px)');
  const ghosts = new Map();
  let sortHome = null;

  function placeSort(root) {
    const wrapper = root.querySelector('#FacetsWrapperDesktop');
    const sort = root.querySelector('#FacetFiltersForm .facet-filters.sorting');
    if (!wrapper || !sort) return;
    if (mobile.matches) {
      if (sort.parentElement === wrapper) return;
      sortHome = { parent: sort.parentElement, next: sort.nextElementSibling };
      wrapper.append(sort);
    } else if (sortHome && sort.parentElement === wrapper) {
      sortHome.parent.insertBefore(sort, sortHome.next?.parentElement === sortHome.parent ? sortHome.next : null);
    }
  }

  function sheetHolder(root) {
    const wrapper = root.querySelector('#FacetsWrapperDesktop');
    if (!wrapper) return null;
    let holder = wrapper.parentElement.querySelector(':scope > .ppv-sheet-holder');
    if (!holder) {
      holder = document.createElement('div');
      holder.className = 'ppv-sheet-holder';
      // Escape schließt wie in der Leiste (das Theme hört nur dort darauf).
      holder.addEventListener('keyup', event => {
        if (typeof window.onKeyUpEscape === 'function') window.onKeyUpEscape(event);
      });
      wrapper.after(holder);
    }
    return holder;
  }

  function liftSheet(details, root) {
    const wrapper = root.querySelector('#FacetsWrapperDesktop');
    const holder = sheetHolder(root);
    if (!wrapper || !holder || details.parentElement !== wrapper) return;
    // Platzhalter: dieselbe Pille, aber ohne ID und ohne js-filter – das Theme darf ihn nie für den Filter halten.
    const ghost = document.createElement('details');
    ghost.className = `${[...details.classList].filter(name => name !== 'js-filter').join(' ')} ppv-summary-ghost`;
    if (details.dataset.ppvKey) ghost.dataset.ppvKey = details.dataset.ppvKey;
    ghost.setAttribute('aria-hidden', 'true');
    ghost.inert = true;
    const summary = details.querySelector(':scope > summary');
    if (summary) {
      const copy = summary.cloneNode(true);
      copy.removeAttribute('id');
      copy.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
      ghost.append(copy);
    }
    details.before(ghost);
    ghosts.set(details, ghost);
    holder.append(details);
  }

  function returnSheet(details) {
    const ghost = ghosts.get(details);
    ghosts.delete(details);
    if (ghost?.isConnected) ghost.replaceWith(details);
  }

  function enhance() {
    const root = document.getElementById('main-collection-filters');
    if (!root) return;
    placeSort(root);
    // Platzhalter, deren Filter das Theme beim Neuzeichnen entfernt hat, verschwinden mit.
    ghosts.forEach((ghost, details) => {
      if (details.isConnected) return;
      ghost.remove();
      ghosts.delete(details);
    });
    const wrapper = root.querySelector('#FacetsWrapperDesktop');
    if (wrapper) {
      const holder = wrapper.parentElement.querySelector(':scope > .ppv-sheet-holder');
      const filters = [...wrapper.querySelectorAll(':scope > details.js-filter'), ...(holder ? holder.querySelectorAll(':scope > details.js-filter') : [])];
      const gender = filters.find(details => filterKey(details) === 'gender');
      genderChips(wrapper, gender);
      filters.forEach(menuChips);
    }
    sorting(root);
    headingCount();
  }

  let frame = 0;
  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      enhance();
    });
  };

  /* Während das Theme neue Ergebnisse lädt (eigene Verzögerung + Abruf), das Raster abblenden – sonst wirkt ein Klick wirkungslos. */
  let fadeTimer = 0;
  function startFade() {
    const grid = document.getElementById('ProductGridContainer');
    if (!grid) return;
    grid.classList.add('ppv-is-filtering');
    window.clearTimeout(fadeTimer);
    fadeTimer = window.setTimeout(stopFade, 8000);
  }
  function stopFade() {
    window.clearTimeout(fadeTimer);
    document.getElementById('ProductGridContainer')?.classList.remove('ppv-is-filtering');
    schedule();
  }

  function start() {
    const root = document.getElementById('main-collection-filters');
    if (!root) return;
    enhance();
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    root.addEventListener('change', schedule);
    root.addEventListener('input', event => {
      if (event.target.matches('.ppv-gender-details input[type="checkbox"]')) exclusiveGender(event.target);
      if (event.target.matches('input[type="checkbox"], select')) startFade();
    });
    root.addEventListener('click', event => {
      if (event.target.closest('facet-remove a, a.facets__reset')) startFade();
    });
    const grid = document.getElementById('ProductGridContainer');
    if (grid) new MutationObserver(stopFade).observe(grid, { childList: true });
    /* Handy: Ein Tipp auf einen Filter in der Wischleiste zieht ihn zuerst in den Halter und öffnet ihn dann – so steht das
       Auswahlblatt nie in der scrollenden Leiste. Ein Tipp auf ✕ entfernt den Filter wie bisher. */
    root.addEventListener('click', event => {
      if (!mobile.matches || event.target.closest('.ppv-chip-clear')) return;
      const summary = event.target.closest('#FacetsWrapperDesktop > details.js-filter > summary');
      const details = summary?.parentElement;
      if (!details || details.open) return;
      event.preventDefault();
      liftSheet(details, root);
      details.open = true;
    }, true);
    /* immer nur ein Auswahlfenster offen; solange eins offen ist, schwebende Knöpfe (Duftfinder, Siegel) ausblenden */
    root.addEventListener('toggle', event => {
      const changed = event.target;
      if (!(changed instanceof HTMLDetailsElement) || !changed.classList.contains('js-filter')) return;
      if (changed.open) {
        root.querySelectorAll('details.js-filter[open]').forEach(details => {
          if (details !== changed) details.removeAttribute('open');
        });
        // Auch per Tastatur oder Skript geöffnet: raus aus der Leiste.
        if (mobile.matches) liftSheet(changed, root);
      } else if (ghosts.has(changed)) {
        returnSheet(changed);
      }
      // Das Theme setzt aria-expanded beim Klick nach dem alten Stand – beim Öffnen aus der Wischleiste wäre es falsch herum.
      changed.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(changed.open));
      document.documentElement.classList.toggle('ppv-filter-sheet-open', !!root.querySelector('details.js-filter[open]'));
    }, true);
    mobile.addEventListener('change', () => {
      root.querySelectorAll('details.js-filter[open]').forEach(details => details.removeAttribute('open'));
      placeSort(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  /* „Mehr anzeigen“: nächste Seite holen und an das Raster anhängen (ohne JavaScript: normaler Link). */
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-ppv-more-next]');
    if (!link) return;
    const nav = link.closest('[data-ppv-more]');
    const grid = document.getElementById('product-grid');
    if (!nav || !grid || event.metaKey || event.ctrlKey || event.shiftKey) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    const label = link.textContent;
    link.setAttribute('aria-busy', 'true');
    link.textContent = 'Lädt …';
    try {
      const url = new URL(link.href, window.location.origin);
      if (nav.dataset.sectionId) url.searchParams.set('section_id', nav.dataset.sectionId);
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const items = [...doc.querySelectorAll('#product-grid > .grid__item')];
      if (!items.length) throw new Error('Keine weiteren Produkte');
      items.forEach(item => {
        item.classList.add('scroll-trigger--cancel');
        grid.append(item);
      });
      const nextNav = doc.querySelector('[data-ppv-more]');
      const shown = nav.querySelector('[data-ppv-more-shown]');
      const nextShown = nextNav?.querySelector('[data-ppv-more-shown]');
      if (shown && nextShown) shown.textContent = nextShown.textContent;
      const nextLink = nextNav?.querySelector('[data-ppv-more-next]');
      if (nextLink) {
        link.href = nextLink.getAttribute('href');
        link.textContent = label;
        link.removeAttribute('aria-busy');
      } else {
        link.remove();
      }
      items[0]?.querySelector('a')?.focus({ preventScroll: true });
    } catch (error) {
      window.location.href = link.href;
    }
  });
})();
